var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"li-container"},[_c('div',{staticClass:"li-label"},[_vm._v(_vm._s(_vm.props.labeledItem.label))]),_c('p',{staticClass:"li-value"},[_vm._v(_vm._s(_vm.props.labeledItem.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }